/**
 * @generated SignedSource<<fbcf29cc6799b61fe8183f2006abc92a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type MarkStudentTargetFocusSeenInput = {
  studentTargetFocusId: string;
};
export type StudentTargetFocusSeenMutation$variables = {
  input: MarkStudentTargetFocusSeenInput;
};
export type StudentTargetFocusSeenMutation$data = {
  readonly markStudentTargetFocusSeen: {
    readonly errors: ReadonlyArray<{
      readonly __typename: string;
      readonly message?: string;
    }> | null | undefined;
    readonly studentTargetFocusNode: {
      readonly focusSeenOn: any | null | undefined;
      readonly id: string;
    } | null | undefined;
  };
};
export type StudentTargetFocusSeenMutation = {
  response: StudentTargetFocusSeenMutation$data;
  variables: StudentTargetFocusSeenMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "MarkStudentTargetFocusSeenPayload",
    "kind": "LinkedField",
    "name": "markStudentTargetFocusSeen",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "StudentTargetFocusNode",
        "kind": "LinkedField",
        "name": "studentTargetFocusNode",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "focusSeenOn",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": null,
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "message",
                "storageKey": null
              }
            ],
            "type": "Error",
            "abstractKey": "__isError"
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "StudentTargetFocusSeenMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "StudentTargetFocusSeenMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "d3d0ba96b9f374e565e646e53a9448ff",
    "id": null,
    "metadata": {},
    "name": "StudentTargetFocusSeenMutation",
    "operationKind": "mutation",
    "text": "mutation StudentTargetFocusSeenMutation(\n  $input: MarkStudentTargetFocusSeenInput!\n) {\n  markStudentTargetFocusSeen(input: $input) {\n    studentTargetFocusNode {\n      id\n      focusSeenOn\n    }\n    errors {\n      __typename\n      ... on Error {\n        __isError: __typename\n        message\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "22b465c392cee7b8cd9bd949a00d8753";

export default node;
